<template>
    <div class="drs">
      <div class="line"/>
    </div>
  </template>